define(['morningstar', 'underscore', './date-helper.js'], function(morningstar, _, dateHelper) {
    'use strict';
    morningstar.asterix.ng.transforms.register('toMarkets', function() {
        var parameters = this.context.parameters;
        if (!parameters.secIds) {
            return;
        }
        var marketsApiToken = morningstar.asterix.context.getToken('marketsApiToken');
        var startDate = _.max([parameters.startDate, parameters.inceptionDate]);
        var endDate = parameters.endDate;
        var beforeEndDate20Y = new Date(endDate.getFullYear() - 20, endDate.getMonth(), endDate.getDate());
        var dataType = startDate <= beforeEndDate20Y ? 'w' : 'd';
        parameters.dataType = dataType;

        var result = {
            baseUrl: this.context.settings.get('baseUrlQuoteSpeed'),
            dataType: dataType,
            startDate: dateHelper.toDateString(startDate),
            endDate: dateHelper.toDateString(endDate),
            secIds: parameters.secIds,
            sessionId: marketsApiToken
        };
        return result;
    });
});



// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/transforms/to-markets.js